/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { GetContactsEmailTransactionsSendErrorsResponseDataFromJSON, GetContactsEmailTransactionsSendErrorsResponseDataToJSON } from './GetContactsEmailTransactionsSendErrorsResponseData';
export function GetContactsEmailTransactionsSendErrorsResponseFromJSON(json) {
    return GetContactsEmailTransactionsSendErrorsResponseFromJSONTyped(json, false);
}
export function GetContactsEmailTransactionsSendErrorsResponseFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        status: !exists(json, 'status') ? undefined : json['status'],
        data: !exists(json, 'data') ? undefined : GetContactsEmailTransactionsSendErrorsResponseDataFromJSON(json['data'])
    };
}
export function GetContactsEmailTransactionsSendErrorsResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        status: value.status,
        data: GetContactsEmailTransactionsSendErrorsResponseDataToJSON(value.data)
    };
}
